import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../apiEndPoint";

import exportKey from "../static/exportKey";

export default {
    getListPembarayan: ({ commit }, payload) => {
        let query = {
            idedc: payload,
        };

        conn.get(api.getListPembarayan, query)
            .then((res) => {
                let { code, data, status, msg } = res.data;
                if (code === 200) {
                    if (status) {
                        commit("setListPembayaran", data);
                        commit("setSelectedPembayaran", data);
                    } else {
                        commit("setResponse", resulter.errorResult(msg));
                    }
                }
            })
            .catch((e) => {
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getQueryStringSettlement: ({ rootGetters, getters }, { key, idedc }) => {
        let getFilter = rootGetters["filterGlobalModule/getFilter"];
        let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"];

        let query = {
            key,
            idedc,
            sort_by: getFilter.sortBy,
            order_by: getFilter.orderBy,
            offset: getters.paginationSettlement.offset,
            limit: getters.paginationSettlement.limit,
        };

        Object.keys(getFilterItem).forEach((key) => {
            if (getFilterItem[key].length > 0) {
                switch (key) {
                    case "karyawan":
                        query.idkaryawan = getFilterItem[key];
                        break;
                    case "akunSettlement":
                        query.idrekening_owner = getFilterItem[key];
                        break;
                    case "statusKonfirmasi":
                        query.status_settlement = getFilterItem[key];
                        break;
                }
            }

            if (key === "periode") {
                query.filter_by = getFilterItem[key].filterBy;
                if (getFilterItem[key].filterBy === "periode") {
                    query.tanggal_awal = getFilterItem[key].startDate;
                    query.tanggal_akhir = getFilterItem[key].endDate;
                }

                if (getFilterItem[key].filterBy === "tahun") {
                    query.tahun = getFilterItem[key].year;
                }
                if (getFilterItem[key].filterBy === "bulan") {
                    query.bulan = getFilterItem[key].month;
                }
            }
        });

        return query;
    },
    getListSettlementEdc: ({ commit, dispatch }, payload) => {
        dispatch("getQueryStringSettlement", payload)
            .then((query) => {
                commit("setFetching", true);
                conn.get(api.getListSettlementEdc, query).then((res) => {
                    let { code, data, status, msg } = res.data;
                    if (code === 200) {
                        conn.setQueryString(query);
                        if (status) {
                            commit("setListSettlementEdc", data);
                            commit("setResponse", resulter.successResult(msg));
                            commit("setEndSettlementOfPage", data.list[data.list.length - 1]);
                            commit("setNextPaginationSettlement", data.list);
                        } else {
                            commit("setResponse", resulter.errorResult(msg));
                        }
                    }
                    commit("setFetching", false);
                    commit("setLoadMore", false);
                });
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setLoadMore", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getDetailSettlementEdc: ({ commit }, payload) => {
        let query = {
            idsettlement_edc: payload,
        };
        commit("setFetching", true);
        conn.get(api.getDetailSettlementEdc, query)
            .then((res) => {
                let { code, data, status, msg } = res.data;
                if (code === 200) {
                    if (status) {
                        commit("setDetailSettlementEdc", data);
                        commit("setResponse", resulter.successResult(msg));
                    } else {
                        commit("setResponse", resulter.errorResult(msg));
                    }
                }
                commit("setFetching", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    saveSettlement: ({ commit }, payload) => {
        let posted = new FormData();

        Object.keys(payload).forEach(function(key) {
            if (key === "waktu_settlement" || key === "waktu_diterima") {
                let date = `${payload[key]}:00`;
                posted.append(key, date.replace("T", " "));
            } else {
                if (key === "bukti_settlement_files" || key === "bukti_mutasi_files") {
                    payload[key].forEach((dtImg) => {
                        posted.append(key, dtImg);
                    });
                } else {
                    posted.append(key, payload[key]);
                }
            }
        });

        commit("setFetching", true);
        return conn.post(api.createSettlement, posted, conn.contentType.form);
    },
    tolakSettlement: ({ commit }, payload) => {
        let posted = new FormData();
        Object.keys(payload).forEach(function(key) {
            posted.append(key, payload[key]);
        });

        commit("setFetching", true);
        return conn.post(api.tolakSettlement, posted, conn.contentType.form);
    },
    setujuiSettlement: ({ commit }, payload) => {
        let posted = new FormData();
        Object.keys(payload).forEach(function(key) {
            if (key === "bukti_mutasi_files") {
                payload[key].forEach((file) => {
                    posted.append(key, file);
                });
            } else {
                if (key === "waktu_diterima") {
                    let date = `${payload[key]}:00`;
                    posted.append(key, date.replace("T", " "));
                } else {
                    posted.append(key, payload[key]);
                }
            }
        });

        commit("setFetching", true);
        return conn.post(api.setujuiSettlement, posted, conn.contentType.form);
    },
    exportSettlementEdc({ commit, dispatch }, payload) {
        dispatch("getQueryStringSettlement", payload)
            .then((query) => {
                let formData = new FormData();
                formData.append("type", exportKey.settlement.job);
                formData.append("filter_json", JSON.stringify(query));

                commit("setExporting", true);
                conn.post(api.export.job, formData, conn.contentType.form).then((response) => {
                    let { status, msg, data } = response.data;
                    if (status === true) {
                        localStorage.setItem("key_export_edc", exportKey.settlement.tracker);
                        commit("setResponse", resulter.successResult(msg));
                    } else {
                        commit("setResponse", resulter.errorResult(msg, data));
                        commit("setExporting", false);
                    }
                });
            })
            .catch((e) => {
                commit("setExporting", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
};
